module.exports = __webpack_public_path__ + "static/media/bus_service_icon_black.6bf03440.svg";